const statuses = [
  {
    label: 'Quote',
    value: 'draft',
    code: 1,
  },
  {
    label: 'Active',
    value: 'active',
    code: 2,
  },
  {
    label: 'Trial Cancelled',
    value: 'trial_cancelled',
    code: 3,
  },
  {
    label: 'Expired',
    value: 'expired',
    code: 4,
  },
  {
    label: 'Cancelled',
    value: 'cancelled',
    code: 5,
  },
];

export default statuses;
